module.exports = __webpack_public_path__ + "img/jboard_icon-43.101fdcae.png";